import React from "react";

const Divider = () => {
  return <div className="start__divider" data-test="divider" />;
};

export default Divider;
